import { faTrophyStar } from '@fortawesome/pro-regular-svg-icons/faTrophyStar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Typography, useTheme } from '@mui/material';
import React from 'react';

interface IProps {
    ranking: number | null;
    subtitle: string;
    size?: "small" | "normal";
}

export const AwardRankingCard: React.FC<IProps> = ({ ranking, subtitle, size = "normal" }) => {

    const theme = useTheme();

    return <Stack direction="row" alignItems="center" spacing={2}>
        <FontAwesomeIcon
            icon={faTrophyStar}
            color={theme.palette.warning.main}
            style={{ fontSize: size == "small" ? 70 : 80 }}
        />
        <Stack direction="column" alignItems="center" spacing={1}>
            <Typography variant="h5" color="muted.main" fontSize="32px">
                {ranking ? <strong>#{ranking}</strong> : "--"}
            </Typography>
            <Typography variant="captionHeader" color="muted.main" textAlign="center" lineHeight="1.1em" sx={{ width: 130 }}>
                {subtitle}
            </Typography>
        </Stack>
    </Stack>;
};
